var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 29,
    fill: "url(#paint0_linear_2_525)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_525)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0625 29.5C84.0625 29.2431 83.9604 28.9967 83.7788 28.815C83.5971 28.6333 83.3507 28.5313 83.0938 28.5313L20.2448 28.5313L26.3421 22.4359C26.4322 22.3458 26.5037 22.2389 26.5524 22.1212C26.6011 22.0035 26.6262 21.8774 26.6262 21.75C26.6262 21.6226 26.6011 21.4965 26.5524 21.3788C26.5037 21.2611 26.4322 21.1542 26.3421 21.0641C26.2521 20.9741 26.1451 20.9026 26.0275 20.8539C25.9098 20.8051 25.7836 20.78 25.6563 20.78C25.5289 20.78 25.4027 20.8051 25.2851 20.8539C25.1674 20.9026 25.0605 20.9741 24.9704 21.0641L17.2204 28.8141C17.1302 28.9041 17.0586 29.011 17.0098 29.1287C16.9609 29.2464 16.9358 29.3726 16.9358 29.5C16.9358 29.6274 16.9609 29.7536 17.0098 29.8713C17.0586 29.989 17.1302 30.0959 17.2204 30.1859L24.9704 37.9359C25.0605 38.026 25.1674 38.0974 25.2851 38.1461C25.4027 38.1949 25.5289 38.22 25.6563 38.22C25.7836 38.22 25.9098 38.1949 26.0275 38.1461C26.1451 38.0974 26.2521 38.026 26.3421 37.9359C26.4322 37.8458 26.5037 37.7389 26.5524 37.6212C26.6011 37.5035 26.6262 37.3774 26.6262 37.25C26.6262 37.1226 26.6011 36.9965 26.5524 36.8788C26.5037 36.7611 26.4322 36.6542 26.3421 36.5641L20.2448 30.4688L83.0938 30.4688C83.3507 30.4688 83.5971 30.3667 83.7788 30.185C83.9604 30.0033 84.0625 29.7569 84.0625 29.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_525",
    x1: -82.4797,
    y1: 31.3455,
    x2: 74.2446,
    y2: 115.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF7912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193,
    stopColor: "#AD7712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1826,
    stopColor: "#A26914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#9E6414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#A36C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4886,
    stopColor: "#B28126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#C9A33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#E0C44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC14D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#D8B847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#CEA83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9768,
    stopColor: "#BF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78624"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 31,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLeft);
export default __webpack_public_path__ + "static/media/ButtonLeft.e8080fe88bca2bfe0d76d7d4918190c6.svg";
export { ForwardRef as ReactComponent };